import type { EmailTemplate } from "@redotech/redo-model/email-template";
import { emailTemplateSchema } from "@redotech/redo-model/email-template";
import type { SavedEmailTemplate } from "@redotech/redo-model/saved-email-template";
import { savedEmailTemplateSchema } from "@redotech/redo-model/saved-email-template";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateSavedEmailTemplate = {
  name: "updateSavedEmailTemplate" as const,
  input: z.object({
    savedTemplateId: zExt.objectId(),
    updates: z
      .object({
        template: (emailTemplateSchema as z.ZodType<EmailTemplate>).optional(),
        templateName: z.string().optional(),
      })
      .partial(),
  }),
  output: savedEmailTemplateSchema as z.ZodType<SavedEmailTemplate>,
};
